import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NotFoundGlyph = /*#__PURE__*/createElement("g", {
  id: "not_found",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M316.5 161C315.672 161 315 160.328 315 159.5C315 158.672 315.672 158 316.5 158H331.5C332.328 158 333 158.672 333 159.5C333 160.328 332.328 161 331.5 161H316.5Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M331.5 159H316.5C316.224 159 316 159.224 316 159.5C316 159.776 316.224 160 316.5 160H331.5C331.776 160 332 159.776 332 159.5C332 159.224 331.776 159 331.5 159ZM315 159.5C315 160.328 315.672 161 316.5 161H331.5C332.328 161 333 160.328 333 159.5C333 158.672 332.328 158 331.5 158H316.5C315.672 158 315 158.672 315 159.5Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M337.667 171.061C338.253 170.475 339.203 170.475 339.789 171.061C340.374 171.646 340.374 172.596 339.789 173.182L324.939 188.031C324.354 188.617 323.404 188.617 322.818 188.031C322.232 187.445 322.232 186.496 322.818 185.91L337.667 171.061Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M324.232 187.324L339.082 172.475C339.277 172.28 339.277 171.963 339.082 171.768C338.886 171.573 338.57 171.573 338.374 171.768L323.525 186.617C323.33 186.812 323.33 187.129 323.525 187.324C323.72 187.519 324.037 187.519 324.232 187.324ZM339.789 171.061C339.203 170.475 338.253 170.475 337.667 171.061L322.818 185.91C322.232 186.496 322.232 187.445 322.818 188.031C323.404 188.617 324.354 188.617 324.939 188.031L339.789 173.182C340.374 172.596 340.374 171.646 339.789 171.061Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M351 193.5C351 194.328 350.328 195 349.5 195C348.672 195 348 194.328 348 193.5V178.5C348 177.672 348.672 177 349.5 177C350.328 177 351 177.672 351 178.5V193.5Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M349 178.5V193.5C349 193.776 349.224 194 349.5 194C349.776 194 350 193.776 350 193.5V178.5C350 178.224 349.776 178 349.5 178C349.224 178 349 178.224 349 178.5ZM349.5 195C350.328 195 351 194.328 351 193.5V178.5C351 177.672 350.328 177 349.5 177C348.672 177 348 177.672 348 178.5V193.5C348 194.328 348.672 195 349.5 195Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M225.5 87C225.5 86.1716 226.172 85.5 227 85.5C227.828 85.5 228.5 86.1716 228.5 87V102C228.5 102.828 227.828 103.5 227 103.5C226.172 103.5 225.5 102.828 225.5 102V87Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.5 102V87C227.5 86.7239 227.276 86.5 227 86.5C226.724 86.5 226.5 86.7239 226.5 87V102C226.5 102.276 226.724 102.5 227 102.5C227.276 102.5 227.5 102.276 227.5 102ZM227 85.5C226.172 85.5 225.5 86.1716 225.5 87V102C225.5 102.828 226.172 103.5 227 103.5C227.828 103.5 228.5 102.828 228.5 102V87C228.5 86.1716 227.828 85.5 227 85.5Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M215.439 108.167C216.025 108.753 216.025 109.703 215.439 110.289C214.854 110.874 213.904 110.874 213.318 110.289L198.469 95.4394C197.883 94.8537 197.883 93.9039 198.469 93.3181C199.055 92.7323 200.004 92.7323 200.59 93.3181L215.439 108.167Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.176 94.7323L214.025 109.582C214.22 109.777 214.537 109.777 214.732 109.582C214.927 109.386 214.927 109.07 214.732 108.874L199.883 94.0252C199.688 93.83 199.371 93.83 199.176 94.0252C198.981 94.2205 198.981 94.5371 199.176 94.7323ZM215.439 110.289C216.025 109.703 216.025 108.753 215.439 108.167L200.59 93.3181C200.004 92.7323 199.055 92.7323 198.469 93.3181C197.883 93.9039 197.883 94.8537 198.469 95.4394L213.318 110.289C213.904 110.874 214.854 110.874 215.439 110.289Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M193 121.5C192.172 121.5 191.5 120.828 191.5 120C191.5 119.172 192.172 118.5 193 118.5H208C208.828 118.5 209.5 119.172 209.5 120C209.5 120.828 208.828 121.5 208 121.5H193Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M208 119.5H193C192.724 119.5 192.5 119.724 192.5 120C192.5 120.276 192.724 120.5 193 120.5H208C208.276 120.5 208.5 120.276 208.5 120C208.5 119.724 208.276 119.5 208 119.5ZM191.5 120C191.5 120.828 192.172 121.5 193 121.5H208C208.828 121.5 209.5 120.828 209.5 120C209.5 119.172 208.828 118.5 208 118.5H193C192.172 118.5 191.5 119.172 191.5 120Z",
  fill: "#686868",
  stroke: "#E2000F"
}), /*#__PURE__*/createElement("path", {
  d: "M168 157L74 157C56.3269 157 42 142.673 42 125L42 42.3888V34C42 16.3269 27.6731 2 10 2H0",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "180",
  y: "148",
  width: "18",
  height: "12",
  rx: "2",
  transform: "rotate(90 180 148)",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "221",
  y: "135.25",
  width: "44",
  height: "40",
  rx: "6",
  transform: "rotate(90 221 135.25)",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "227",
  y: "126.25",
  width: "62",
  height: "10",
  rx: "2",
  transform: "rotate(90 227 126.25)",
  fill: "white",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "254",
  y: "143",
  width: "3",
  height: "28",
  rx: "1.5",
  transform: "rotate(90 254 143)",
  fill: "#686868",
  stroke: "#E2000F",
  strokeWidth: "2"
}), /*#__PURE__*/createElement("rect", {
  x: "254",
  y: "168",
  width: "3",
  height: "28",
  rx: "1.5",
  transform: "rotate(90 254 168)",
  fill: "#686868",
  stroke: "#E2000F",
  strokeWidth: "2"
}), /*#__PURE__*/createElement("path", {
  d: "M410 127L526 127C543.673 127 558 141.327 558 159V298.5",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "408",
  y: "118",
  width: "18",
  height: "12",
  rx: "2",
  transform: "rotate(90 408 118)",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "395",
  y: "105",
  width: "44",
  height: "40",
  rx: "6",
  transform: "rotate(90 395 105)",
  stroke: "#E2000F",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("rect", {
  x: "359",
  y: "96",
  width: "62",
  height: "10",
  rx: "2",
  transform: "rotate(90 359 96)",
  fill: "white",
  stroke: "#E2000F",
  strokeWidth: "4"
}));
const NotFound = createSvg({
  name: 'not_found',
  path: NotFoundGlyph
});

export default NotFound;
export { NotFoundGlyph };
